import {
  Companies,
  CompaniesTable,
  Processes,
  ProcessesTable,
  Trainings,
  TrainingsTable,
  Users,
  UsersTable,
  Zahtjev,
  ZahtjevTable,
} from '../types/types';
import { statusZahtjeva } from '../initialValues/initialValues';

import image1 from '../../assets/images/test-image.svg';

//Pretvorba računa iz odgovora tako da se mogu koristiti u aplikaciji s checkboxom
export function zahtjevToZahtjevTable(zahtjevi: Zahtjev[]): ZahtjevTable[] {
  let zahtjeviTable: ZahtjevTable[] = [];

  for (let zahtjev of zahtjevi) {
    zahtjeviTable.push({ ...zahtjev, key: zahtjev.ID });
  }
  return zahtjeviTable;
}

export function usersToUsersTable(users: Users[]): UsersTable[] {
  let usersTable: UsersTable[] = [];

  for (let user of users) {
    usersTable.push({ ...user, key: user.id });
  }

  return usersTable;
}

export function companiesToCompaniesTable(companies: Companies[]): CompaniesTable[] {
  let companiesTable: CompaniesTable[] = [];

  for (let company of companies) {
    companiesTable.push({ ...company, key: company.id });
  }

  return companiesTable;
}

export function processesToProcessesTable(processes: Processes[]): ProcessesTable[] {
  let processesTable: ProcessesTable[] = [];

  for (let process of processes) {
    processesTable.push({ ...process, key: process.Id });
  }

  return processesTable;
}

export function trainingToTrainingTable(training: Trainings[]): TrainingsTable[] {
  let TrainingTable: TrainingsTable[] = [];
  return (TrainingTable = [
    {
      id: 1,
      company: 'Bartog d.o.o',
      VAT: 'SI79128718',
      dateTrained: '17.10.2022',
      trainedBy: 'Petar Zrinski',
      image: image1,
      key: 1,
    },
    {
      id: 2,
      company: 'Orbico d.o.o',
      VAT: '85611744662',
      dateTrained: '10.10.2022.',
      trainedBy: 'Wade Warren',
      image: image1,
      key: 2,
    },
  ]);
}

export function pretvoriStatusZahtjevaUFormatTablice(value: number | null, undefinedText: String): string {
  return value != null && value > 0 && value < 8 ? (statusZahtjeva.find((val) => val.value === value)?.label as string) : (undefinedText as string);
}

export const pretvoriDatumuFormatTablice = (value: string | undefined | null, undefinedText: String): string => {
  if (value != null) {
    const date = new Date(value);
    const month = date.toLocaleString('en-EU', { month: '2-digit' });
    const day = date.toLocaleString('en-EU', { day: '2-digit' });
    const year = date.getFullYear();
    const time = date.toLocaleTimeString('en-EU', { hour12: false });
    const fullTime: string = day + '.' + month + '.' + year + '. ' + time;
    return fullTime;
  } else return undefinedText as string;
};
export const pretvoriDatumuFormatTabliceSimple = (value: string | undefined | null, undefinedText: String): string => {
  if (value != null) {
    const date = new Date(value);
    const month = date.toLocaleString('en-EU', { month: '2-digit' });
    const day = date.toLocaleString('en-EU', { day: '2-digit' });
    const year = date.getFullYear();
    const fullTime: string = day + '.' + month + '.' + year + '.';
    return fullTime;
  } else return undefinedText as string;
};

export const searchRequestDate = (value: Date | undefined | null, search: boolean) => {
  if (value != null) {
    const date = new Date(value);
    const month = date.toLocaleString('en-EU', { month: '2-digit' }); //numeric
    const day = date.toLocaleString('en-EU', { day: '2-digit' }); //short
    const year = date.getFullYear();
    let fullDate: string;
    search ? (fullDate = year + '-' + month + '-' + day) : (fullDate = day + '.' + month + '.' + year);
    return fullDate;
  }
};
export const DatePlusYear = (value: Date | undefined | null) => {
  if (value != null) {
    const date = new Date(value);
    const month = date.toLocaleString('en-EU', { month: '2-digit' }); //numeric
    const day = date.toLocaleString('en-EU', { day: '2-digit' }); //short
    const year = date.getFullYear() + 1;
    let fullDate: string = year + '-' + month + '-' + day;
    return fullDate;
  }
};

export const searchRequestDateRange = (value: Array<Date> | undefined | null, search: boolean) => {
  let fullDate: string = '';
  if (value != null) {
    value.forEach((element) => {
      const date = new Date(element);
      let month = date.toLocaleString('en-EU', { month: '2-digit' });
      let day = date.toLocaleString('en-EU', { day: '2-digit' });
      let year = date.getFullYear();
      if (fullDate) {
        search ? (fullDate += ',') : (fullDate += ' - ');
        if (
          ((month === '01' || month === '03' || month === '05' || month === '07' || month === '08' || month === '10' || month === '12') &&
            day === '31') ||
          ((month === '04' || month === '06' || month === '09' || month === '11') && day === '30') ||
          (month === '02' && (day === '28' || day == '29'))
        ) {
          month = (Number(month) + 1).toString();
          if (month.length < 2) month = '0' + month;
          if (month === '13' && day === '31') {
            month = '01';
            year++;
          }
          day = '01';
        } else {
          day = (Number(day) + 1).toString();
          if (day.length < 2) day = '0' + day;
        }
      }
      search ? (fullDate += year + '-' + month + '-' + day) : (fullDate += day + '.' + month + '.' + year);
    });
    return fullDate;
  }
};
